import Address from '@/models/Address'

export class AddressTransformer {
    transform (data) {
        return new Address(
            data.label,
            data.country,
            data.state,
            data.county,
            data.city,
            data.district,
            data.street,
            data.houseNumber,
            data.postalCode
        )
    }
}
